import React from 'react'
import AuthProvider from './src/components/AuthProvider/AuthProvider'
import Layout from './src/components/Layout/Layout'
import { useGAUserTracking } from './src/hooks/useGAUserTracking'
import './src/styles/global.css'

// Re-typeset MathJax equations on route update (for client-side navigation)
const onRouteUpdate = () => {
  if (window.MathJax?.typesetPromise) {
    window.MathJax.typesetPromise()
  }
}

const shouldUpdateScroll = () => {
  if (!window.location.href.includes('#')) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    return false
  }
  return true
}

// Component wrapper to use the GA user tracking hook
const GAUserTrackingWrapper = ({ children }: { children: React.ReactNode }) => {
  useGAUserTracking()
  return <>{children}</>
}

const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return (
    <AuthProvider>
      <GAUserTrackingWrapper>{element}</GAUserTrackingWrapper>
    </AuthProvider>
  )
}

const wrapPageElement = ({ element }: { element: React.ReactNode }) => {
  return <Layout>{element}</Layout>
}

export { wrapRootElement, wrapPageElement, shouldUpdateScroll, onRouteUpdate }
